import React, { useContext, lazy, Suspense, } from "react";
import { useTranslation, } from "react-i18next";
import ReactDOM from "react-dom";
import FirebaseContext, { FirebaseProvider, } from "contexts/firebase";
import Loader from "components/Loader";
import ErrorWithRetry from "components/ErrorWithRetry";
import "moment/min/locales";
import moment from "moment";
import "./i18n";
import "./styles.css";

moment.locale(navigator.language);

const App = lazy(() => import("./App"));

const WithFirebase = () => {
  const [t] = useTranslation();
  const firebaseContext = useContext(FirebaseContext);

  if (firebaseContext.firebaseConfig === undefined) {
    return <Loader type="linear" message={`${t("Inicializando plataforma")}...`} />;
  } else if (firebaseContext.firebaseConfig === false) {
    return (
      <ErrorWithRetry message="Ocorreu um erro ao inicializar a plataforma. Tente novamente." />
    );
  }

  return (
    <Suspense fallback={<Loader type="linear" message={t("Ambiente iniciado")} />}>
      <App />
    </Suspense>
  );
};

ReactDOM.render(
  <FirebaseProvider>
    <WithFirebase />
  </FirebaseProvider>,
  document.getElementById("root")
);
